export default {
    actions: {},
    mutations: {
        setCourse: function (state, data) {
            state.course = data;
        },
        setCurrency: function (state, data) {
            state.currency = data;
        },
        addSum: function (state, data) {
            state.sum += +data;
        },
        setUserInfo: function (state, data) {
            state.userInfo = data;
        }
    },
    getters: {
        getSum: state => state.sum,
        getCourse: state => state.course,
        getCurrency: state => state.currency,
        getUserInfo: state => state.userInfo
    },
    state: {
        sum: 0,
        course: null,
        currency: null,
        userInfo: null
    },
};
